import * as React from 'react';

import {classify} from 'src/utils/classify';

import css from './drop-indicator.css';


export type DropIndicatorOrientation = 'vertical' | 'horizontal';

export type DropIndicatorProps = {
  orientation: DropIndicatorOrientation;
  offset: number;
};

export const DropIndicator = React.memo(
  ({orientation, offset}: DropIndicatorProps) => {
    const style: React.CSSProperties | undefined =
      orientation === 'vertical' ? {left: offset} : undefined;
    return (
      <div
        aria-hidden
        className={classify(
          css.indicator,
          orientation === 'vertical'
            ? css.indicatorVertical
            : css.indicatorHorizontal,
        )}
        style={style}
      />
    );
  },
);
